export interface StripeSubscription {
  id: string;
  cancel_at: Date;
  cancel_at_period_end: boolean;
  current_period_start: Date;
  current_period_end: Date;
  ended_at: Date;
  status: SubscriptionStatus;
  trial_end: Date;
  trial_start: Date;
  items: StripeSubscriptionItem[];
  // Add other fields as necessary
}

export interface StripeSubscriptionItem {
  id: string;
  price: StripePrice;
  quantity: number;
  // Add other fields as necessary
}

export interface StripePrice {
  id: string;
  active: boolean;
  currency: string;
  unit_amount: number;
  type:string;
  product: StripeProduct;
  recurring: StripePriceRecurring;
  // Add other fields as necessary
}

export interface StripePriceRecurring {
  interval: string;
  interval_count: number;
  trial_period_days: number;
  // Add other fields as necessary
}

export interface StripeProduct {
  name: string;
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIALING = 'trialing',
  CANCELED = 'canceled',
  INDETERMINATE = 'indeterminate'
};

